import { render, staticRenderFns } from "./DatosTarjeta.vue?vue&type=template&id=3ddf4f1b"
import script from "./DatosTarjeta.vue?vue&type=script&lang=js"
export * from "./DatosTarjeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports